module.exports = __webpack_public_path__ + "static/media/alexa.09c372cd.png";